import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import * as Validation from "../../../../constants/validation.constants";
import {CommonService} from "../../../../services/common.service";
import {PhoneNumberFormatPipe} from "../../../../pipes/phone-number-format.pipe";
import {Store} from "@ngrx/store";
import * as fromRoot from "../../../../../../state/app.state";
import {GenerateOtpRequest, VerifyOtpRequest} from "../../../../core/shared.actions";
import {generateOtpInfo, verifyOtpInfo} from "../../../../core/shared.selectors";
import {Subject, takeUntil} from "rxjs";

@Component({
  selector: 'app-edit-phone-number',
  templateUrl: './edit-phone-number.component.html',
  styleUrls: ['./edit-phone-number.component.css']
})
export class EditPhoneNumberComponent implements OnInit, OnDestroy {
  private readonly OnDestroy: Subject<any> = new Subject<any>();
  @Input() data;
  validation = Validation;
  errorMessages: any = {};
  errorMessageMap = {
    phoneNumber: {
      required: 'This field is required.'
    },
    otp: {
      required: "This field is required.",
      minlength: "OTP is incomplete",
      maxlength: "Maximum 6 digits accepted",
    }
  }
  otpSent: boolean = false;
  generateOtpLoading: boolean = false;
  verifyOtpLoading: boolean = false;

  form = new FormGroup<any>({
    phoneNumber: new FormControl({
      value: '', disabled: false
    }, {
      validators: [
        Validators.required,
        Validators.minLength(this.validation['phoneNumber'].length.min)
      ]
    }),
  })

  constructor(
    private commonService: CommonService,
    private store: Store<fromRoot.State>,
    private phoneNumberFormatPipe: PhoneNumberFormatPipe
  ) {
  }

  ngOnInit() {
    this.form.patchValue({
      phoneNumber: this.data.phoneNumber
    });

    this.store
      .select(generateOtpInfo)
      .pipe(takeUntil(this.OnDestroy))
      .subscribe(data => {
        this.otpSent = data?.otpSent
        this.generateOtpLoading = data?.loading

        if (this.otpSent) {
          this.form.controls['phoneNumber'].disable();
          this.form.addControl('otp', new FormControl({value: '', disabled: false}, {
            validators: [
              Validators.required,
              Validators.minLength(this.validation.onboarding.otp.length.min),
              Validators.maxLength(this.validation.onboarding.otp.length.max),
            ]
          }))
        } else {
          this.form.removeControl('otp');
          this.form.controls['phoneNumber'].enable();
        }
      });

    this.store
      .select(verifyOtpInfo)
      .pipe(takeUntil(this.OnDestroy))
      .subscribe(data => {
        this.verifyOtpLoading = data.loading;
      });
  }

  checkForErrors(currentField?: string) {
    this.errorMessages = {
      ...this.errorMessages,
      ...(this.commonService.checkFormValidation(this.form, this.errorMessageMap, currentField))
    };
  }

  getOtp() {
    // ERROR CHECK IN THE FORM//
    if (this.form.invalid) {
      this.checkForErrors();
      return;
    }

    if(!this.form.controls['phoneNumber'].dirty) {
      return;
    }
    // EXTRACT VALUE FROM FORM//
    const phoneNumber = this.phoneNumberFormatPipe.cleanPhoneNumber(this.form.getRawValue().phoneNumber);
    // PAYLOAD CREATION//
    const payload = {
      phoneNumber
    };
    // ACTION DISPATCH to get OTP
    this.store.dispatch(GenerateOtpRequest({payload}));
  }

  verifyOtp() {
    // ERROR CHECK IN THE FORM//
    if (this.form.invalid) {
      this.checkForErrors();
      return;
    }
    // EXTRACT VALUE FROM FORM//
    const {otp} = this.form.getRawValue();
    // PAYLOAD CREATION//
    const payload = {
      otp
    };
    // ACTION DISPATCH to get OTP
    this.store.dispatch(VerifyOtpRequest({payload}));
  }

  handleSuffixClick() {
    this.form.controls['phoneNumber'].enable();
    this.otpSent = false;
    this.form.removeControl('otp');
  }

  ngOnDestroy() {
    this.OnDestroy.next(null);
    this.OnDestroy.complete();
  }

}
